<template>
  <svg :width="width" :height="height" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23 19C23 20.6569 21.6569 22 20 22C18.3431 22 17 20.6569 17 19C17 17.3431 18.3431 16 20 16C21.6569 16 23 17.3431 23 19Z"
      fill="#05070F"
    />
    <path
      d="M37 19C37 20.6569 35.6569 22 34 22C32.3431 22 31 20.6569 31 19C31 17.3431 32.3431 16 34 16C35.6569 16 37 17.3431 37 19Z"
      fill="#05070F"
    />
    <path
      d="M44 19C44 20.6569 42.6569 22 41 22C39.3431 22 38 20.6569 38 19C38 17.3431 39.3431 16 41 16C42.6569 16 44 17.3431 44 19Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.87121 4C7.31823 4 6.00187 5.31092 6.00187 7V71C6.00187 72.6891 7.31823 74 8.87121 74H59.1847C60.7377 74 62.0541 72.6891 62.0541 71V54C62.0541 53.4477 62.5022 53 63.055 53C63.6078 53 64.056 53.4477 64.056 54V71C64.056 73.7292 61.9068 76 59.1847 76H8.87121C6.1492 76 4 73.7292 4 71V7C4 4.2708 6.1492 2 8.87121 2H59.1847C61.9068 2 64.056 4.2708 64.056 7V20C64.056 20.5523 63.6078 21 63.055 21C62.5022 21 62.0541 20.5523 62.0541 20V7C62.0541 5.31092 60.7377 4 59.1847 4H8.87121Z"
      fill="#05070F"
    />
    <path
      d="M14.3056 36.08H14.8741V35.08C16.1393 34.992 16.8119 34.224 16.8119 33.264C16.8119 32.152 16.0753 31.752 14.8741 31.568V30.136C15.2985 30.216 15.4987 30.472 15.5708 30.888H16.7158C16.6198 29.856 15.9631 29.312 14.8741 29.216V28.496H14.3056V29.208C13.1605 29.288 12.4238 29.968 12.4238 30.888C12.4238 31.944 13.0324 32.408 14.3056 32.608V34.152C13.673 34.056 13.5049 33.68 13.4488 33.216H12.2637C12.3278 34.224 12.9203 34.984 14.3056 35.08V36.08ZM13.5769 30.784C13.5769 30.448 13.8332 30.184 14.3056 30.12V31.472C13.713 31.352 13.5769 31.152 13.5769 30.784ZM15.6268 33.4C15.6268 33.792 15.3386 34.072 14.8741 34.152V32.696C15.4667 32.824 15.6268 33.016 15.6268 33.4Z"
      fill="#05070F"
    />
    <path d="M34.7052 32.088H38.3566V31.104H34.7052V32.088Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0084 20C13.5612 20 14.0093 19.5523 14.0093 19C14.0093 18.4477 13.5612 18 13.0084 18C12.4556 18 12.0075 18.4477 12.0075 19C12.0075 19.5523 12.4556 20 13.0084 20ZM13.0084 22C14.6668 22 16.0112 20.6569 16.0112 19C16.0112 17.3431 14.6668 16 13.0084 16C11.35 16 10.0056 17.3431 10.0056 19C10.0056 20.6569 11.35 22 13.0084 22Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.0215 20C27.5742 20 28.0224 19.5523 28.0224 19C28.0224 18.4477 27.5742 18 27.0215 18C26.4687 18 26.0205 18.4477 26.0205 19C26.0205 19.5523 26.4687 20 27.0215 20ZM27.0215 22C28.6798 22 30.0242 20.6569 30.0242 19C30.0242 17.3431 28.6798 16 27.0215 16C25.3631 16 24.0187 17.3431 24.0187 19C24.0187 20.6569 25.3631 22 27.0215 22Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M48.041 20C48.5938 20 49.042 19.5523 49.042 19C49.042 18.4477 48.5938 18 48.041 18C47.4882 18 47.0401 18.4477 47.0401 19C47.0401 19.5523 47.4882 20 48.041 20ZM48.041 22C49.6994 22 51.0438 20.6569 51.0438 19C51.0438 17.3431 49.6994 16 48.041 16C46.3826 16 45.0382 17.3431 45.0382 19C45.0382 20.6569 46.3826 22 48.041 22Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.0476 20C55.6004 20 56.0485 19.5523 56.0485 19C56.0485 18.4477 55.6004 18 55.0476 18C54.4948 18 54.0466 18.4477 54.0466 19C54.0466 19.5523 54.4948 20 55.0476 20ZM55.0476 22C56.706 22 58.0504 20.6569 58.0504 19C58.0504 17.3431 56.706 16 55.0476 16C53.3892 16 52.0448 17.3431 52.0448 19C52.0448 20.6569 53.3892 22 55.0476 22Z"
      fill="#05070F"
    />
    <path
      d="M15.0103 54.5C15.0103 55.3284 14.3381 56 13.5089 56C12.6797 56 12.0075 55.3284 12.0075 54.5C12.0075 53.6716 12.6797 53 13.5089 53C14.3381 53 15.0103 53.6716 15.0103 54.5Z"
      fill="#05070F"
    />
    <path
      d="M15.0103 59.5C15.0103 60.3284 14.3381 61 13.5089 61C12.6797 61 12.0075 60.3284 12.0075 59.5C12.0075 58.6716 12.6797 58 13.5089 58C14.3381 58 15.0103 58.6716 15.0103 59.5Z"
      fill="#05070F"
    />
    <path
      d="M15.0103 64.5C15.0103 65.3284 14.3381 66 13.5089 66C12.6797 66 12.0075 65.3284 12.0075 64.5C12.0075 63.6716 12.6797 63 13.5089 63C14.3381 63 15.0103 63.6716 15.0103 64.5Z"
      fill="#05070F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M28.0224 33H18.0131V29H28.0224V33Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M48.041 33H40.0336V29H48.041V33Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.0187 12.5H12.0075V10.5H24.0187V12.5Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M40.0336 12.5H28.0224V10.5H40.0336V12.5Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M56.0485 12.5H44.0373V10.5H56.0485V12.5Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M48.041 42.5H12.0075V40.5H48.041V42.5Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M40.0336 48H12.0075V46H40.0336V48Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M36.0298 55.5H18.0131V53.5H36.0298V55.5Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M40.0336 60.5H18.0131V58.5H40.0336V60.5Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M30.0242 65.5H18.0131V63.5H30.0242V65.5Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M63 46.2685C68.1278 46.2685 72.2745 42.1132 72.2745 37C72.2745 31.8868 68.1278 27.7315 63 27.7315C57.8722 27.7315 53.7255 31.8868 53.7255 37C53.7255 42.1132 57.8722 46.2685 63 46.2685ZM63 48C69.0751 48 74 43.0751 74 37C74 30.9249 69.0751 26 63 26C56.9249 26 52 30.9249 52 37C52 43.0751 56.9249 48 63 48Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M68.4903 32.7129C68.8318 33.0463 68.8392 33.5944 68.5069 33.9371L60.7484 41.938L57.4656 38.2262C57.1493 37.8686 57.1818 37.3215 57.5382 37.0041C57.8945 36.6867 58.4398 36.7193 58.7561 37.0769L60.8066 39.3953L67.2703 32.7296C67.6026 32.3869 68.1488 32.3794 68.4903 32.7129Z"
      fill="#FF0064"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'AppliedIllustration',
  props: {
    width: {
      type: Number,
      default: 78,
    },
    height: {
      type: Number,
      default: 78,
    },
  },
};
</script>
